<template lang="pug">
.form-price.center(:class="{'inside-padding': !fillData}")
  h2.title {{ title }}
  form.form-add-price(@submit.prevent="" autocomplete="off")
    .form-section
      .input-container.arrow
        select.select(v-model="price.person"  autocomplete="ño" required)
          option(v-for="person in persons" :value="person.person") ({{ capitalize(person.letter) }}) {{ capitalize(person.person) }}
        label.label(:class="{ show: price.person }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="person" title="Persona")

      .input-container.arrow
        select.select(v-model="price.article"  autocomplete="ño" required)
          option(v-for="article in articles" :value="article.article") ({{ capitalize(article.letter) }}) {{ capitalize(article.article) }}
        label.label(:class="{ show: price.article }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="article" title="Artículo")

      .input-container.arrow
        select.select(v-model="price.design"  autocomplete="ño" required)
          option(v-for="design in designs" :value="design") {{ capitalize(design) }}
        label.label(:class="{ show: price.design }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="design" title="Diseño")

      .input-container
        input.input(v-model.number="price.value" type="number" min="500" max="10000000" autocomplete="ño" required)
        label.label(:class="{ show: price.value }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="product" title="Value")

    shActionButton(:isForm="true" :action="addPrice" text="Agregar Precio" textRunning="Agregando Precio" :normalColor="true")

  form(@submit.prevent="" autocomplete="off")
    .form-section
      .input-container
        input.input(v-model="dataForm.price" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.price }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="price" title="Nombre de Lista de Precios")

    .list-price-container(v-for="(persons, person) in prices")
      h3.capitalize {{ person }}
      div(v-for="(articles, article) in persons")
        div(v-for="(value, design) in articles")
          .prices-container
            span.capitalize {{ article }} - {{ design }}
            span.no-wrap {{ money(value) }}
            span
              shActionButton(:action="deletePriceList" :params="[person, article, design]" text="Eliminar" textRunning="Eliminando" :mini="true")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deletePrice")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlPrice from '@/graphql/price'
import shDeleteButton from '@/components/elements/DeleteButton'
import shInputImage from '@/components/elements/InputImage'
import shProperty from '@/components/elements/Property'

export default {
  name: 'FormPrice',

  mixins: [mForm, mDB, mFilters],

  components: { shDeleteButton, shInputImage, shProperty },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        price: '',
        stringPrice: ''
      },
      price: {
        article: '',
        person: '',
        value: '',
        design: ''
      },
      prices: {},
      resolver: 'price',
      key: 'price',
      gql: gqlPrice,
      imageLoaded: false,
      classContainerImage: 'button-price'
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
    this.parseJSONPrices()
  },

  methods: {
    sendForm () {
      this.stringifyPrices()

      if (!this.fillData) {
        this.newPrice()
      } else {
        this.updatePrice()
      }
    },

    newPrice () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updatePrice () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deletePrice () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    addPrice () {
      const price = this.price
      if (!this.prices[price.person]) this.$set(this.prices, price.person, {})
      if (!this.prices[price.person][price.article]) this.$set(this.prices[price.person], price.article, {})
      this.$set(this.prices[price.person][price.article], price.design, price.value)
    },

    deletePriceList (person, article, design) {
      if (this.prices[person] && this.prices[person][article] && this.prices[person][article][design]) this.$delete(this.prices[person][article], design)
    },

    parseJSONPrices () {
      this.prices = this.dataForm.stringPrice ? JSON.parse(this.dataForm.stringPrice) : {}
    },

    stringifyPrices () {
      this.dataForm.stringPrice = JSON.stringify(this.prices)
    }
  },

  computed: {
    persons () {
      return this.$store.state.persons
    },
    articles () {
      return this.$store.state.variables.articles
    },
    designs () {
      return this.$store.state.variables.designs
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-price
  position relative

.button-price
  border none
  border-radius .8em
  //borderRadius(.8em)
  font-size 1.2em
  font-weight 600
  transition all .2s ease-in
  box-shadow 0px 0px 20px -2px rgba(0, 0, 0, .9)
  display inline-flex
  height 4em
  width 4em
  justify-content space-around
  //boxShadow(0px 8px 20px -2px rgba(0, 0, 0, .9))

.button-price:hover
  box-shadow 0px 0px 20px -2px #ffdc65

.button-price img
  align-self center
  height 2.2em
  width 2.2em

.form-add-price
  margin-bottom 2em

.prices-container
  display inline-flex
  gap 1em
  margin .5em
  align-items center

.list-price-container
  margin-bottom 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/price/Form.vue